export const isDisabled = function () {
  let selfDisabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  let parentDisabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return selfDisabled || parentDisabled;
};
export const createHashTable = function () {
  let treeNodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let hashTable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();
  for (const treeNode of treeNodes) {
    hashTable.set(treeNode.id, treeNode);
    if (treeNode?.children) {
      createHashTable(treeNode.children, hashTable);
    }
  }
  return hashTable;
};
export const isKeyMatched = function () {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return keys.some(key => e.key === key || e.keyCode === key);
};